import {INVOICES_DOWNLOAD_URL} from "../config";
import {getAccessToken} from "./api/AuthApi";

const InvoiceStorage = {

  getUrl(invoiceNr) {
    return INVOICES_DOWNLOAD_URL.replace(":invoice_nr", invoiceNr);
  },

  download(url, openOption = "_self") {
    const token = getAccessToken()
    const url_with_token = url.includes("?")
      ? `${url}&token=${token}`
      : `${url}?token=${token}`;
    window.open(url_with_token, openOption);
  }

}

export default InvoiceStorage;